import { makeAutoObservable } from 'mobx';
import { push, replace } from './navigation';

// Minimal replacement for mobx-react-router's RouterStore.
// Keeps the existing API surface (`routing.push(...)`) used throughout the app.
export default class RoutingStore {
  location = { pathname: '/' };

  constructor() {
    makeAutoObservable(this);
  }

  setLocation(location) {
    // store only what we use today
    this.location = { pathname: location?.pathname || '/' };
  }

  push(path) {
    push(path);
  }

  replace(path) {
    replace(path);
  }
}
